import src from "IMAGE";
export default { src, width: 1920, height: 390, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAAN0lEQVR42i2LsREAMQjDsMkBhv/91w1FVOokaxVVCZKWGcgIuDsWO8dh/wy/6Y2KLVE7TOu5xAUrkQF4OAR05QAAAABJRU5ErkJggg=="};
